export default "__VITE_ASSET__987ef468__"